export default __webpack_public_path__ + "static/media/Snd_LowerEBall.ca1d85ff.mp3";